{
  "entry": {
    "title": "Entri Order",
    "subtitle": "Computerized Provider Order Entry (CPOE)",
    "searchSection": {
      "title": "Cari & Tambah Order",
      "cosignNotice": "Order Anda memerlukan kontrasi dokter penanggung jawab sebelum aktivasi."
    },
    "pending": {
      "title": "Order Menunggu",
      "clearAll": "Hapus Semua",
      "collapseAria": "Tutup detail",
      "expandAria": "Buka detail",
      "removeAria": "Hapus order",
      "startDateTime": "Tanggal/Waktu Mulai",
      "ariaStartDate": "Tanggal mulai order",
      "ariaStartTime": "Waktu mulai order",
      "clinicalIndication": "Indikasi Klinis",
      "clinicalIndicationPlaceholder": "Alasan order…",
      "specialInstructions": "Instruksi Khusus",
      "specialInstructionsPlaceholder": "Instruksi tambahan untuk unit pelaksana…",
      "diagnosisLabel": "Diagnosis (ICD-10)",
      "diagnosisPlaceholder": "Cari kode diagnosis ICD-10…",
      "noActiveEncounter": "Tidak ada kunjungan aktif — order tidak dapat dibuat.",
      "placing": "Mengirim…",
      "placeAll": "Kirim Semua Order ({{count}})"
    },
    "active": {
      "title": "Order Aktif",
      "loading": "Memuat order…",
      "emptyAll": "Tidak ada order untuk pasien ini.",
      "emptyFiltered": "Tidak ada order {{type}}.",
      "columns": {
        "orderNumber": "No. Order",
        "name": "Nama",
        "type": "Tipe",
        "priority": "Prioritas",
        "status": "Status",
        "orderedBy": "Diorder Oleh",
        "orderedDate": "Tanggal Order",
        "actions": "Tindakan"
      },
      "external": "Eksternal",
      "externalTitle": "Order eksternal dari {{source}}",
      "externalTitleWithId": "Order eksternal dari {{source}} (#{{id}})",
      "providerPlaceholder": "Dokter #{{id}}",
      "actions": {
        "complete": "Selesai",
        "cancel": "Batal",
        "completeTooltip": "Selesaikan order",
        "cancelTooltip": "Batalkan order"
      }
    },
    "cancelDialog": {
      "title": "Batalkan Order",
      "prompt": "Berikan alasan pembatalan {{orderName}}.",
      "placeholder": "Alasan pembatalan (wajib)…",
      "goBack": "Kembali",
      "confirm": "Konfirmasi Batal"
    },
    "toast": {
      "cancelSuccess": "Order berhasil dibatalkan",
      "cancelError": "Gagal membatalkan order",
      "completeSuccess": "Order ditandai selesai",
      "completeError": "Gagal menyelesaikan order",
      "noActiveEncounter": "Tidak ada kunjungan aktif untuk pasien ini. Buat kunjungan terlebih dahulu.",
      "placedSuccess_one": "{{count}} order berhasil dikirim",
      "placedSuccess_other": "{{count}} order berhasil dikirim",
      "medicationFieldsRequired_one": "{{names}} memerlukan dosis, rute, dan frekuensi sebelum dapat diresepkan",
      "medicationFieldsRequired_other": "{{count}} obat memerlukan dosis, rute, dan frekuensi: {{names}}",
      "medicationNotInFormulary_one": "{{names}} tidak tertaut ke formularium dan tidak dapat disaring untuk alergi, interaksi, atau dosis — resepkan dari halaman obat",
      "medicationNotInFormulary_other": "{{count}} obat tidak tertaut ke formularium dan tidak dapat disaring: {{names}} — resepkan dari halaman obat",
      "placedError_one": "{{count}} order gagal dikirim",
      "placedError_other": "{{count}} order gagal dikirim",
      "orderSetApplied": "Menambahkan {{count}} pesanan dari {{name}} — tinjau sebelum menandatangani"
    }
  },
  "catalog": "Katalog Order",
  "orderedBy": "Diperintahkan Oleh",
  "orderedDate": "Tanggal Order",
  "scheduledDate": "Tanggal Terjadwal",
  "completedDate": "Tanggal Selesai",
  "lab": "Laboratorium",
  "imaging": "Pencitraan",
  "medication": "Obat",
  "procedure": "Prosedur",
  "consultation": "Konsultasi",
  "priority": {
    "label": "Prioritas",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "Mendesak",
      "routine": "Rutin",
      "scheduled": "Terjadwal",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "Status Order",
    "values": {
      "draft": "Draf",
      "pending": "Menunggu",
      "pendingCosign": "Menunggu Kontrasi",
      "signed": "Ditandatangani",
      "sent": "Terkirim",
      "active": "Aktif",
      "ordered": "Diperintahkan",
      "inProgress": "Dalam Proses",
      "holdForVerify": "Tahan untuk Verifikasi",
      "completed": "Selesai",
      "cancelled": "Dibatalkan",
      "discontinued": "Dihentikan",
      "archived": "Diarsipkan",
      "pendingClarification": "Menunggu Klarifikasi",
      "suspended": "Ditangguhkan",
      "unknown": "Tidak Diketahui"
    }
  },
  "entryFields": {
    "searchPlaceholder": "Cari order (lab, pencitraan, obat, prosedur)…",
    "frequency": "Frekuensi",
    "dose": "Dosis",
    "route": "Rute Pemberian",
    "indication": "Indikasi",
    "duration": "Durasi",
    "comments": "Catatan",
    "signOrder": "Tandatangani Order",
    "holdOrder": "Tahan Order",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "Katalog Order",
    "searchPlaceholder": "Cari berdasarkan nama, kode, atau sinonim…",
    "categories": "Kategori",
    "favorites": "Favorit",
    "recentlyUsed": "Baru Digunakan",
    "restricted": "Terbatas",
    "searchCatalog": "Cari Katalog",
    "tabs": {
      "all": "Semua",
      "lab": "Lab",
      "imaging": "Pencitraan",
      "medication": "Obat",
      "procedure": "Prosedur",
      "consultation": "Konsultasi"
    },
    "columns": {
      "orderName": "Nama Order",
      "code": "Kode",
      "category": "Kategori",
      "description": "Deskripsi",
      "defaultPriority": "Prioritas Default"
    },
    "details": {
      "orderCode": "Kode Order",
      "category": "Kategori",
      "defaultPriority": "Prioritas Default",
      "status": "Status",
      "cptCode": "Kode CPT",
      "loincCode": "Kode LOINC",
      "synonyms": "Sinonim",
      "description": "Deskripsi",
      "active": "Aktif",
      "inactive": "Nonaktif"
    },
    "loading": "Memuat katalog…",
    "loadError": "Gagal memuat katalog order",
    "emptyResults": "Tidak ada order yang sesuai dengan kriteria.",
    "pagination": "Menampilkan {{from}}-{{to}} dari {{total}}",
    "pageIndicator": "Halaman {{page}} dari {{totalPages}}",
    "favoriteAdd": "Tambah ke favorit",
    "favoriteRemove": "Hapus dari favorit",
    "favoriteAdded": "Ditambahkan ke favorit",
    "favoriteRemoved": "Dihapus dari favorit"
  },
  "cosign": {
    "title": "Antrean Tanda Tangan Bersama",
    "requiresCosign": "Perlu Tanda Tangan Bersama",
    "cosignedBy": "Ditandatangani Bersama oleh",
    "cosignDeadline": "Batas Tanda Tangan Bersama",
    "queueEmpty": "Tidak ada order yang memerlukan tanda tangan bersama.",
    "pendingCount": "{{count}} menunggu",
    "loading": "Memuat antrean tanda tangan bersama…",
    "loadError": "Gagal memuat antrean tanda tangan bersama.",
    "columns": {
      "patient": "Pasien",
      "order": "Order",
      "type": "Tipe",
      "orderingProvider": "Dokter Pengorder",
      "priority": "Prioritas",
      "orderedDate": "Tanggal Order",
      "action": "Aksi"
    },
    "actions": {
      "cosign": "Tanda Tangan Bersama"
    },
    "toast": {
      "success": "Order berhasil ditandatangani bersama",
      "error": "Gagal menandatangani order bersama"
    },
    "cosigningAs": "Menandatangani bersama sebagai: {{name}}"
  },
  "sets": {
    "title": "Order Set",
    "newOrderSet": "Order Set Baru",
    "addItem": "Tambah Item",
    "requiredItem": "Wajib",
    "optionalItem": "Opsional",
    "editMode": "Mode Edit",
    "published": "Dipublikasikan",
    "draft": "Draf",
    "archived": "Diarsipkan",
    "versionNotes": "Catatan Versi",
    "createTitle": "Buat Order Set Baru",
    "fields": {
      "name": "Nama",
      "category": "Kategori",
      "specialty": "Spesialisasi",
      "description": "Deskripsi"
    },
    "placeholders": {
      "name": "Mis. Penanganan Nyeri Dada",
      "categorySelect": "Pilih kategori…",
      "specialty": "Mis. Kedokteran Darurat",
      "description": "Deskripsi singkat…",
      "search": "Cari order set…"
    },
    "categories": {
      "chestPain": "Nyeri Dada",
      "sepsis": "Sepsis",
      "postOp": "Pasca Operasi",
      "admission": "Rawat Inap",
      "discharge": "Pulang",
      "other": "Lainnya"
    },
    "statusFilter": {
      "all": "Semua Status",
      "active": "Aktif",
      "draft": "Draf",
      "archived": "Diarsipkan"
    },
    "columns": {
      "name": "Nama",
      "category": "Kategori",
      "specialty": "Spesialisasi",
      "items": "Item",
      "status": "Status",
      "version": "Versi",
      "actions": "Aksi"
    },
    "itemColumns": {
      "seq": "Urut",
      "type": "Tipe",
      "item": "Item",
      "priority": "Prioritas",
      "required": "Wajib"
    },
    "itemTypes": {
      "order": "Order",
      "sectionHeader": "Judul Bagian",
      "instruction": "Instruksi"
    },
    "actions": {
      "publish": "Publikasikan",
      "archive": "Arsipkan",
      "cancel": "Batal",
      "create": "Buat",
      "removeItem": "Hapus item"
    },
    "loading": "Memuat order set…",
    "loadError": "Gagal memuat order set",
    "emptyResults": "Tidak ada order set yang ditemukan.",
    "expandLoading": "Memuat item…",
    "expandEmpty": "Order set ini tidak memiliki item.",
    "validationRequired": "Nama, kategori, dan spesialisasi wajib diisi",
    "toast": {
      "created": "Order set berhasil dibuat",
      "createError": "Gagal membuat order set",
      "published": "Order set dipublikasikan",
      "publishError": "Gagal mempublikasikan order set",
      "archived": "Order set diarsipkan",
      "archiveError": "Gagal mengarsipkan order set",
      "itemRemoved": "Item dihapus",
      "itemRemoveError": "Gagal menghapus item"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "Cari order (lab, pencitraan, obat, prosedur)…",
    "noResults": "Tidak ada order yang ditemukan untuk \"{{query}}\"",
    "categories": {
      "all": "Semua",
      "lab": "Lab",
      "imaging": "Pencitraan",
      "med": "Obat",
      "procedure": "Prosedur",
      "consultation": "Konsultasi"
    },
    "addAll": "Tambah semua {{count}}"
  },
  "worklist": {
    "title": "Daftar Kerja Order",
    "countBadge": "{{count}} order",
    "loading": "Memuat order…",
    "loadError": "Tidak dapat memuat order. Silakan coba lagi.",
    "empty": "Tidak ada order yang cocok dengan filter saat ini.",
    "typeLabel": "Jenis Order",
    "allOption": "Semua",
    "columns": {
      "patient": "Pasien",
      "order": "Order",
      "type": "Jenis",
      "priority": "Prioritas",
      "status": "Status",
      "ordered": "Dipesan"
    }
  }
}
